// Recent + favourite brand slugs, persisted locally. No user account exists
// yet (see Phase 7 FitMap Passport for the broader device-profile
// direction) — this is deliberately small and self-contained rather than
// pre-building a shared "profile" abstraction before it's needed.

const RECENT_KEY = 'fitmap:recent-brands';
const FAVORITE_KEY = 'fitmap:favorite-brands';
const MAX_RECENT = 6;

function readList(key: string): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

function writeList(key: string, list: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, JSON.stringify(list));
  } catch {
    // Storage unavailable (private browsing, quota, etc.) — fail silently, not fatal to search.
  }
}

export function getRecentBrandSlugs(): string[] {
  return readList(RECENT_KEY);
}

export function addRecentBrandSlug(slug: string): void {
  const list = readList(RECENT_KEY).filter((s) => s !== slug);
  list.unshift(slug);
  writeList(RECENT_KEY, list.slice(0, MAX_RECENT));
}

export function getFavoriteBrandSlugs(): string[] {
  return readList(FAVORITE_KEY);
}

/** Toggles favourite status and returns the resulting list. */
export function toggleFavoriteBrandSlug(slug: string): string[] {
  const list = readList(FAVORITE_KEY);
  const next = list.includes(slug) ? list.filter((s) => s !== slug) : [...list, slug];
  writeList(FAVORITE_KEY, next);
  return next;
}
